import React from 'react';
import meetgeekLogo from '../../assets/images/meetgeekicon.webp';

/**
 * Meetgeek wordmark (wide purple text asset).
 * Size = height in px; width scales naturally.
 */
export default function MeetGeekLogo({ size = 28, className = '' }) {
  return (
    <img
      src={meetgeekLogo}
      alt="Meetgeek"
      height={size}
      className={`mg-meetgeek-logo${className ? ` ${className}` : ''}`}
      style={{ height: size, width: 'auto' }}
      draggable={false}
    />
  );
}
